import React from "react";
import { Grid, Card, CardContent, Typography, Box } from "@mui/material";
import { MatxLayoutSettings } from "app/components/MatxLayout/settings";
import { formatCurrency, getSoldCount } from "../utils/dashboardUtils";

const StatCards = ({ summaryData, ticketProducts }) => {
  return (
    <Grid container spacing={2} sx={{ mt: 3 }}>
      <Grid item xs={12} sm={6} md={3}>
        <Card sx={{ borderRadius: "10px", border: `1px solid ${MatxLayoutSettings.palette.borderGrey}`, boxShadow: "none" }}>
          <CardContent sx={{ p: { xs: 1.5, sm: 2 }, "&:last-child": { pb: ticketProducts?.length ? 2 : 6 } }}>
            <Typography variant="caption" fontWeight="700" color={MatxLayoutSettings.palette.black} sx={{ textTransform: "uppercase" }}>
              TOTAL REGISTRATIONS
            </Typography>
            <Typography variant="h5" fontWeight="800" sx={{ mt: 0.5, fontSize: { xs: "1.25rem", sm: "1.5rem" } }} color={MatxLayoutSettings.palette.active}>
              {summaryData?.total_registrations || 0}
            </Typography>
            {ticketProducts.map((product) =>
              product.categories.map((category) =>
                category.variations
                  .map((variation) => (
                    <Box key={variation.variation_id} display="flex" justifyContent="space-between" alignItems="center">
                      <Typography variant="body1" fontWeight="500">{variation.variation_name}</Typography>
                      <Box display="flex" alignItems="center" gap={1}>
                        <Typography variant="body1" fontWeight="700">{getSoldCount(variation)}</Typography>
                      </Box>
                    </Box>
                  ))
              )
            )}
          </CardContent>
        </Card>
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <Card sx={{ borderRadius: "10px", border: `1px solid ${MatxLayoutSettings.palette.borderGrey}`, boxShadow: "none", height: "100%" }}>
          <CardContent sx={{ p: { xs: 1.5, sm: 2 }, "&:last-child": { pb: 2 } }}>
            <Typography variant="caption" fontWeight="700" color={MatxLayoutSettings.palette.black} sx={{ textTransform: "uppercase" }}>
              TOTAL SALES
            </Typography>
            <Typography variant="h5" fontWeight="800" sx={{ mt: 0.5, fontSize: { xs: "1.25rem", sm: "1.5rem" } }} color={MatxLayoutSettings.palette.active}>
              {formatCurrency(summaryData?.total_amount)}
            </Typography>
            <Typography variant="caption" color={MatxLayoutSettings.palette.textBlack} fontWeight="600">Overall Revenue Generated
            </Typography>
          </CardContent>
        </Card>
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <Card sx={{ borderRadius: "10px", border: `1px solid ${MatxLayoutSettings.palette.borderGrey}`, boxShadow: "none", height: "100%" }}>
          <CardContent sx={{ p: { xs: 1.5, sm: 2 }, "&:last-child": { pb: 2 } }}>
            <Typography variant="caption" fontWeight="700" color={MatxLayoutSettings.palette.black} sx={{ textTransform: "uppercase" }}>
              COLLECTED
            </Typography>
            <Typography variant="h5" fontWeight="800" sx={{ mt: 0.5, fontSize: { xs: "1.25rem", sm: "1.5rem" } }} color={MatxLayoutSettings.palette.active}>
              {formatCurrency(summaryData?.total_amount_paid)}
            </Typography>
            <Typography variant="caption" color={MatxLayoutSettings.palette.textBlack} fontWeight="600">Total Amount Received</Typography>
          </CardContent>
        </Card>
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <Card sx={{ borderRadius: "10px", border: `1px solid ${MatxLayoutSettings.palette.borderGrey}`, boxShadow: "none", height: "100%" }}>
          <CardContent sx={{ p: { xs: 1.5, sm: 2 }, "&:last-child": { pb: 2 } }}>
            <Typography variant="caption" fontWeight="700" color={MatxLayoutSettings.palette.black} sx={{ textTransform: "uppercase" }}>
              OUTSTANDING
            </Typography>
            <Typography variant="h5" fontWeight="800" sx={{ mt: 0.5, fontSize: { xs: "1.25rem", sm: "1.5rem" } }} color={MatxLayoutSettings.palette.active}>
              {formatCurrency((summaryData?.total_amount || 0) - (summaryData?.total_amount_paid || 0))}
            </Typography>
            <Typography variant="caption" color={MatxLayoutSettings.palette.textBlack} fontWeight="600">Balance to collect</Typography>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

export default StatCards;
